module.exports = __webpack_public_path__ + "media/images/icons/filled/medium-square-4630bfe0e089ee82920df55fc98d3a68.svg";